const config = {
  defaultChapter: "MAT.1"
};

export default config;
